import ImpressionObserver from './observer';
import { hashImpression32 } from '../hasher/hashImpression32';
var LAST_SEEN_CACHE_SIZE = 500; // cache up to 500 impression hashes

var BrowserImpressionObserverFactory = function BrowserImpressionObserverFactory() {
  return new ImpressionObserver(LAST_SEEN_CACHE_SIZE, hashImpression32);
};

export default BrowserImpressionObserverFactory;